export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w@3x.c720a987.webp";